module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "danmu-page"
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.searchForm
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.goSearch($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "查询月份"
    }
  }, [_c('el-form-item', {
    staticClass: "begin-item"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "editable": false,
      "type": "month",
      "placeholder": "选择月份"
    },
    model: {
      value: (_vm.searchForm.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "beginTime", $$v)
      },
      expression: "searchForm.beginTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "过滤未开播数据"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "开",
      "off-text": "关"
    },
    model: {
      value: (_vm.searchForm.filterOnline),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "filterOnline", $$v)
      },
      expression: "searchForm.filterOnline"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "native-type": "submit"
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "数据说明",
      "type": "info",
      "description": "数据每日统计一次。受斗鱼API和采集周期所限：进入房间人数为10级以上数据；最高人气数、最高关注数为每日采集数据的最高值，采集间隔为5分钟可能并非当日极值。2017年9月试运行期间数据采集存在不稳定情况，其中1、2、3、14日的关注数为手动修复数据，且缺失大量开播情况数据。"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('chart', {
    ref: "danmu",
    staticClass: "statistics-chart",
    attrs: {
      "options": _vm.chartOption.danmuOption
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('chart', {
    ref: "composite",
    staticClass: "statistics-chart",
    attrs: {
      "options": _vm.chartOption.compositeOption
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.statisticsList,
      "stripe": "",
      "default-sort": {
        prop: 'calculatedDate',
        order: 'ascending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "calculatedDate",
      "label": "统计日期",
      "sortable": "",
      "formatter": _vm.dateFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "danmuSum",
      "label": "弹幕总数",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "speakSum",
      "label": "发言人数",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "enterSum",
      "label": "进入房间人数",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "onlineMax",
      "label": "最高人气数",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fansMax",
      "label": "最高关注数",
      "sortable": ""
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac525ed8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/statistics.vue
// module id = 487
// module chunks = 1